<template>
    <div class="mt-3 container" id="promotions" v-if="homepageBanners">
        <div class="flex flex-wrap flex-justify-center flex-align-center row">
            <div class="col-xs-12 col-lg-6 mb-4 mb-3-sm" v-for="(banner, i) in homepageBanners" :key="i">
                <promotion-banner-timer :banner="banner" v-if="banner.expiresOn" />
                <promotion-banner :banner="banner" v-else />
            </div>
        </div>
    </div>
</template>

<script>
import { mapState } from 'vuex';
import PromotionBanner from '~/components/common/promotion-banner/promotion-banner';
import PromotionBannerTimer from '~/components/common/promotion-banner/promotion-banner-timer';

const page = route => ({
    '/iranout': 'international-flight',
    '/train-ticket': 'train',
    '/bus-ticket': 'bus',
    '/tour': 'tour',
    '/hotel': 'hotel',
}[route] || 'domestic-flight');

export default {
    components: {
        PromotionBanner,
        PromotionBannerTimer,
    },
    computed: {
        ...mapState(['promotionBanners']),

        homepageBanners () {
            const banners = (this.promotionBanners || {})[page(this.$route.path)];
            return (banners || []);
        },
    },
    mounted () {
        this.homepageBanners.length && this.sendEvent('Show');
        if (this.$route.hash === '#promotions') {
            window.scrollTo({
                top: this.$el.offsetTop - 350,
                behavior: 'smooth',
            });
        }
    },
    methods: {
        sendEvent (eventLabel) {
            this.$gtm.sendGTMEvent({
                event: 'event',
                eventCategory: 'UX',
                eventAction: 'Offer Test',
                eventLabel,
            });
        },
    },
};
</script>

<style lang="scss" scoped>
@import '~vars';
</style>
